(() => {
  const config = document.querySelector('[data-bs-cart-config]');
  if (!config || window.blueStarsCartExtras) return;
  const root = config.dataset.root;
  const timerKey = 'blue-stars-checkout-reminder-until';
  const getStored = () => { try { return Number(sessionStorage.getItem(timerKey)); } catch { return 0; } };
  const clearTimer = () => { try { sessionStorage.removeItem(timerKey); } catch {} };
  if (Number(config.dataset.cartCount) === 0) clearTimer();
  let deadline = getStored();
  class BlueStarsCartReminder extends HTMLElement {
    connectedCallback() {
      if (!deadline) {
        deadline = Date.now() + Number(this.dataset.duration || 300) * 1000;
        try { sessionStorage.setItem(timerKey, String(deadline)); } catch {}
      }
      this.interval = setInterval(() => this.tick(), 1000);
      this.tick();
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      const clock = this.querySelector('time');
      if (clock) clock.textContent = Math.floor(remaining / 60).toString().padStart(2, '0') + ':' + (remaining % 60).toString().padStart(2, '0');
      if (remaining === 0) {
        this.textContent = config.dataset.ready;
        clearInterval(this.interval);
      }
    }
  }
  if (!customElements.get('bs-cart-reminder')) customElements.define('bs-cart-reminder', BlueStarsCartReminder);
  const status = document.createElement('div');
  status.className = 'bs-cart-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  document.body.append(status);
  document.addEventListener('click', event => {
    const link = event.target.closest('.bs-cart-full-link');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    location.assign(link.href);
  }, true);
  let noticeTimeout;
  const notify = message => {
    status.textContent = message;
    clearTimeout(noticeTimeout);
    noticeTimeout = setTimeout(() => { status.textContent = ''; }, 6000);
  };
  const ids = () => [...new Set(['cart-drawer', 'cart-icon-bubble', document.querySelector('#main-cart-items')?.dataset.id, document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean))].slice(0, 5);
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const render = async (sections, cart) => {
    const drawer = document.querySelector('cart-drawer');
    const wasOpen = drawer?.classList.contains('active');
    const bodyScroll = drawer?.querySelector('.cart-drawer__body')?.scrollTop || 0;
    const focused = document.activeElement;
    const focusId = focused?.id;
    const guardFocus = focused?.matches('[data-blueguard-toggle]');
    for (const [id, html] of Object.entries(sections)) {
      if (!html) continue;
      const doc = parse(html);
      if (id === 'cart-drawer') {
        const target = document.getElementById('CartDrawer');
        const next = doc.getElementById('CartDrawer');
        if (target && next) target.innerHTML = next.innerHTML;
        drawer?.classList.toggle('is-empty', cart.item_count === 0);
      } else if (id === 'cart-icon-bubble') {
        const target = document.getElementById(id);
        const next = doc.getElementById(id);
        if (target) target.innerHTML = next?.innerHTML || html;
      } else {
        const current = document.getElementById('shopify-section-' + id);
        const next = doc.getElementById('shopify-section-' + id);
        if (current) current.innerHTML = next?.innerHTML || html;
      }
    }
    if (wasOpen && drawer) {
      drawer.classList.add('active');
      const body = drawer.querySelector('.cart-drawer__body');
      if (body) body.scrollTop = bodyScroll;
    }
    if (guardFocus) document.querySelector(wasOpen ? 'cart-drawer [data-blueguard-toggle]' : '#main-cart-footer [data-blueguard-toggle]')?.focus({preventScroll: true});
    else if (focusId) document.getElementById(focusId)?.focus({preventScroll: true});
    document.querySelectorAll('[data-blueguard-toggle]').forEach(input => { input.checked = cart.items.some(item => Number(item.variant_id) === Number(document.querySelector('[data-blueguard-config]')?.dataset.variant)); });
    if (!cart.item_count) { deadline = 0; clearTimer(); }
  };
  const refresh = async cart => {
    const url = new URL(location.href);
    url.searchParams.set('sections', ids().join(','));
    const response = await fetch(url.href, {cache: 'no-store'});
    if (!response.ok) throw new Error(config.dataset.error);
    await render(await response.json(), cart);
  };
  let queue = Promise.resolve();
  let pending = 0;
  const busy = value => {
    document.querySelectorAll('[data-bs-offer-add], [data-bs-offer-variant], [name="checkout"]').forEach(input => { if (input.dataset.bsDisabled !== undefined || !input.disabled) { if (value) { input.dataset.bsDisabled = ''; input.disabled = true; } else if (input.dataset.bsDisabled !== undefined) { input.disabled = false; delete input.dataset.bsDisabled; } } });
  };
  const add = async input => {
    const card = input.closest('[data-bs-cart-offer]');
    const variant = Number(card.querySelector('[data-bs-offer-variant]')?.value || input.dataset.variant);
    card.setAttribute('aria-busy', 'true');
    const current = await fetch(root + 'cart.js', {cache: 'no-store'}).then(response => response.json());
    if (current.items.some(item => Number(item.variant_id) === variant)) { await refresh(current); notify(config.dataset.already); return; }
    const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: variant, quantity: 1}], sections: ids(), sections_url: location.pathname})});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || config.dataset.error);
    const cart = await fetch(root + 'cart.js', {cache: 'no-store'}).then(response => response.json());
    if (result.sections) await render(result.sections, cart);
    else await refresh(cart);
    notify(config.dataset.added);
  };
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-bs-offer-variant]')) {
      event.stopImmediatePropagation();
      const price = Number(input.selectedOptions[0].dataset.price);
      input.closest('[data-bs-cart-offer]').querySelector('[data-bs-offer-price]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: config.dataset.currency}).format(price / 100);
      return;
    }
    if (!input.matches('[data-bs-offer-add]')) return;
    event.stopImmediatePropagation();
    if (!input.checked) return;
    pending++;
    busy(true);
    const task = () => add(input).catch(error => { input.checked = false; input.closest('[data-bs-cart-offer]')?.removeAttribute('aria-busy'); notify(error.message || config.dataset.error); });
    queue = queue.then(task, task).finally(() => { pending--; if (pending === 0) busy(false); });
  }, true);
  document.addEventListener('bs:cart-updated', event => { if (!event.detail.cart.item_count) { deadline = 0; clearTimer(); } });
  document.addEventListener('submit', event => {
    if (!pending || !event.submitter?.matches('[name="checkout"]')) return;
    event.preventDefault();
    notify(config.dataset.wait);
  }, true);
  window.blueStarsCartExtras = {render, refresh};
})();
